/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSpidersEventItem } from './CRSFSpidersEventItem';
import {
    CRSFSpidersEventItemFromJSON,
    CRSFSpidersEventItemFromJSONTyped,
    CRSFSpidersEventItemToJSON,
} from './CRSFSpidersEventItem';

/**
 * 
 * @export
 * @interface CRSFSpidersPagedResponse
 */
export interface CRSFSpidersPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFSpidersPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSpidersPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSpidersEventItem>}
     * @memberof CRSFSpidersPagedResponse
     */
    results?: Array<CRSFSpidersEventItem>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSpidersPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFSpidersPagedResponse interface.
 */
export function instanceOfCRSFSpidersPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSpidersPagedResponseFromJSON(json: any): CRSFSpidersPagedResponse {
    return CRSFSpidersPagedResponseFromJSONTyped(json, false);
}

export function CRSFSpidersPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSpidersPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSpidersEventItemFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFSpidersPagedResponseToJSON(value?: CRSFSpidersPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSpidersEventItemToJSON)),
        'total': value.total,
    };
}

